export default {
  namespaced: true,
  state: {
    loading: false
  },
  mutations: {
    changeLoading(state, payload) {
      state.loading = payload
    }
  },
  actions: {
    changeLoading({ commit }, payload) {
      commit('changeLoading', payload)
    }
  },
  getters: {
    loading: state => state.loading
  }
}
